exports["NL"] = require("./NL.js");
exports["ES"] = require("./ES.js");
exports["FR"] = require("./FR.js");
exports["UK"] = require("./UK.js");